import { pickClientCompanyNumber } from '../services/supabaseService';

function clientBullhornIdDigits(company: any): string {
    if (!company) return '';
    const raw =
        company.bullhorn_id ??
        (company.data && typeof company.data === 'object' ? (company.data as { bullhorn_id?: unknown }).bullhorn_id : undefined);
    if (raw == null || String(raw).trim() === '') return '';
    return String(raw).replace(/\D/g, '');
}

/** Vier cijfers voor weergave (CRM-lijst, filters, vacature-header) — primair `clients.bullhorn_id`. */
export function formatClientFourDigitId(company: any): string {
    const bh = clientBullhornIdDigits(company);
    if (bh.length >= 4) return bh.slice(-4);
    if (bh.length > 0) return bh.padStart(4, '0');

    const raw = pickClientCompanyNumber(company);
    const digits = String(raw || '').replace(/\D/g, '');
    if (digits.length >= 4) return digits.slice(-4);
    if (digits.length > 0) return digits.padStart(4, '0');
    return '';
}

/** «3325 Werfplaats» — nummer vóór bedrijfsnaam. */
export function formatClientNameWithFourDigit(company: any | null | undefined): string {
    if (!company) return '—';
    const name = String(company.name || '').trim();
    const num = formatClientFourDigitId(company);
    if (!name) return num;
    return `${num} ${name}`;
}
